<template>
  <div id="partner-picker">
    <template v-if="isLoading">
      <div class="loading-screen">
        <loader-ring />
      </div>
    </template>
    <template v-else>
      <div class="selections">
        <div class="page-action-wrapper" :class="{ 'has-error': errorCode }">
          <rounded-button
            width="90px"
            height="30px"
            position="center"
            :isOutline="true"
            @click="getUserCoords(true)"
          >
            <img src="/static/icons/compass-icon.svg" height="25px" />
          </rounded-button>
          <div class="error-message" v-if="errorCode && errorCode == 1">
            {{ $t(`deliveryScreen.partnerPicker.geoLocation.${errorCode}`) }}
          </div>
        </div>
        <div class="moving-wrapper">
          <extra-switch
            v-model="movingType"
            :fontSize="'16px'"
            :leftValue="1"
            :rightValue="2"
            :beforeText="$t('deliveryScreen.partnerPicker.moving.from')"
            :afterText="$t('deliveryScreen.partnerPicker.moving.to')"
          />
        </div>
        <div class="partner-selector-wrapper">
          <auto-complete
            :keys="partners.map(x => x.id)"
            :values="partners.map(item => partnerAutoCompleteText(item))"
            v-model="selectedPartner"
            :placeholderText="$t('deliveryScreen.partnerPicker.partnerSelect')"
            :label="$t('deliveryScreen.partnerPicker.partnerSelect')"
            :canAddNewOption="false"
            :needScroll="true"
            :needDelete="false"
          />
          <div
            class="selected-partner"
            ref="selected-partner"
            v-if="this.selectedPartner"
          >
            <div class="left-side">
              <div
                :class="[
                  {
                    name: true,
                    'close-to':
                      selected && selected.distance && selected.distance < 0.2
                  }
                ]"
              >
                {{
                  $t("deliveryScreen.partnerPicker.selectedPartner.name", {
                    partner: selected.name
                  })
                }}
              </div>
              <div class="location">
                {{
                  $t("deliveryScreen.partnerPicker.selectedPartner.location", {
                    location: selected.location
                  })
                }}
              </div>
            </div>
            <div class="right-side">
              <location-icon :isCloseTo="selected.distance < 0.2" />
            </div>
          </div>
        </div>
        <transition name="fade">
          <partner-box-types
            v-if="partnerBoxes.length !== 0"
            :boxes="partnerBoxes"
          />
        </transition>
      </div>
    </template>
  </div>
</template>

<script>
import PartnerBoxTypes from "./PartnerBoxTypes";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "PartnerPicker",
  props: {},
  components: {
    PartnerBoxTypes
  },
  data: () => ({
    partners: [],
    userCoords: undefined,
    selectedPartner: undefined,
    movingType: undefined,
    partnerBoxes: [],
    partnerLoading: false,
    isLoading: false,
    errorCode: undefined
  }),
  created() {
    this.isLoading = true;
    this.getPartnersFromStorage();
    this.getUserCoords();
  },
  watch: {
    getPartner() {
      if (this.getPartner.moved) {
        this.movingType = this.getPartner.moved;
      }
      if (this.getPartner.partner) {
        this.selectedPartner = this.getPartner.partner.id;
      }
    },
    selectedPartner() {
      if (this.selectedPartner !== undefined) {
        this.getPartnerBoxes();
        if (this.movingType !== undefined) {
          this.savePartner({
            partner: this.selected,
            moved: this.movingType
          });
        }
      } else {
        this.removePartner();
      }
    },
    movingType() {
      if (this.selectedPartner !== undefined && this.movingType !== undefined) {
        this.savePartner({
          partner: this.selected,
          moved: this.movingType
        });
      } else {
        this.removePartner();
      }
    },
    userCoords() {
      if (this.userCoords) {
        this.setDistance();
      }
    }
  },
  computed: {
    ...mapGetters({
      getPartner: "moving/getPartner",
      getPartners: "partners/getPartners"
    }),
    selected() {
      return this.partners.find(x => x.id === this.selectedPartner);
    },
    readedBoxesInfo() {
      const data = {};
      data["readedBoxes"] = this.partnerBoxes;
      data["types"] = this.boxesTypesWithCount();
      return data;
    }
  },
  methods: {
    ...mapActions({
      readPartners: "partners/readPartners",
      savePartner: "moving/savePartner",
      removeQR: "moving/removeQR",
      removePartner: "moving/removePartner",
      readBoxes: "boxes/readBoxes",
      saveQR: "moving/saveQR"
    }),
    scrollToThePartner() {
      setTimeout(() => {
        this.$refs["selected-partner"].scrollIntoView();
      }, 200);
    },
    setBoxes() {
      this.saveQR(this.partnerBoxes);
      if (this.getPartner.moved && this.getPartner.partner) {
        this.$parent.currentScreenIndex = 2;
      }
    },
    getPartnerBoxes() {
      // this.$parent.buttonLoading = true;
      this.readBoxes({
        filter: {
          partnerID: this.selectedPartner,
          // placement: 2,
          onlyOldBoxes: process.env.VUE_APP_ONLY_OLD_BOXES
        }
      }).then(res => {
        if (res.status === "OK") {
          this.partnerBoxes = res.data;
          if (res.data.length > 0) {
            setTimeout(() => {
              if (document.getElementById("boxes")) {
                document.getElementById("boxes").scrollIntoView();
              }
            }, 250);
          }
        }
        this.scrollToThePartner();
        // this.$parent.buttonLoading = false;
      });
      // .catch(() => (this.$parent.buttonLoading = false));
    },
    getUserCoords(needReload = false) {
      this.isLoading = true;
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          pos => {
            this.userCoords = pos.coords;
            this.$emit("getCoords", pos.coords);
            this.errorCode = undefined;
            this.setDistance();
          },
          err => {
            if (needReload) {
              location.reload();
            }
            this.errorCode = err.code;
            this.$emit("coordsError", err);
            this.isLoading = false;
          },
          { timeout: 10000 }
        );
      } else {
        this.isLoading = false;
      }
    },
    partnerAutoCompleteText(item) {
      if (this.userCoords) {
        return `${item.name} - ${item.distance}km`;
      } else {
        return item.name;
      }
    },
    getPartnersFromStorage() {
      this.partners = this.getPartners;
      if (this.userCoords) {
        this.setDistance();
      } else {
        this.getUserCoords();
      }
      if (this.getPartner.moved) {
        this.movingType = this.getPartner.moved;
      }
      if (this.getPartner.partner) {
        this.selectedPartner = this.getPartner.partner.id;
      }
    },
    setDistance() {
      this.isLoading = true;
      this.partners.map(x => {
        const coords = JSON.parse(x.coordinates);
        x["distance"] =
          Math.round(this.calculateDistance(coords.lat, coords.long) * 100) /
          100;
      });
      this.partners.sort(function(a, b) {
        return a["distance"] - b["distance"];
      });
      this.isLoading = false;
    },
    calculateDistance(lat2, lon2) {
      const lat1 = this.userCoords.latitude;
      const lon1 = this.userCoords.longitude;
      if (lat1 == lat2 && lon1 == lon2) {
        return 0;
      } else {
        var radlat1 = (Math.PI * lat1) / 180;
        var radlat2 = (Math.PI * lat2) / 180;
        var theta = lon1 - lon2;
        var radtheta = (Math.PI * theta) / 180;
        var dist =
          Math.sin(radlat1) * Math.sin(radlat2) +
          Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
          dist = 1;
        }
        dist = Math.acos(dist);
        dist = (dist * 180) / Math.PI;
        dist = dist * 60 * 1.1515;
        dist = dist * 1.609344;
        return dist;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#partner-picker {
  padding-top: 20px;
  padding-bottom: 20px;
  margin: auto;
  max-width: 500px;
  min-height: 500px;
  .page-action-wrapper {
    &.has-error {
      text-align: center;
      color: red;
      .error-message {
        margin-top: 10px;
      }
    }
  }
  .loading-screen {
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .welcome-message {
    margin-bottom: 70px;
    .welcome-title {
      font-weight: 550;
    }
    .welcome-text {
      font-size: 13px;
      font-weight: 550;
      color: #5a5a5a;
    }
  }
  .selections {
    .moving-wrapper {
      width: fit-content;
      margin: auto;
      margin-bottom: 40px;
      margin-top: 35px;
    }
    .partner-selector-wrapper {
      .selected-partner {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .left-side {
          .name {
            font-size: 15px;
            font-weight: 550;
            color: red;
          }
          .close-to {
            color: #4e9607 !important;
          }
          .location {
            font-size: 14px;
            color: $color-primary;
          }
        }
        .right-side {
          width: 40px;
        }
      }
    }
  }
}
</style>
